import Moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import RegularCheckbox from 'components/Checkbox/RegularCheckbox';
import ConditionalWrapper from 'components/ConditionalWrapper/ConditionalWrapper';

const columnConfig = ({
  t,
  state,
  massDeleteHandleSingleCheckbox,
  massDeleteHandleMultipleCheckboxes,
  allIds = [],
  classes,
  checkIsGoodspeedZone,
  autoSyncEnabled,
}) => [
  {
    id: 'mass-delete',
    name: 'delete',
    Header: (
      <div className={classes.headerCheckboxWrapper}>
        <RegularCheckbox
          customClasses={{ root: classes.checkboxTitle }}
          checked={
            state.zonesIds.length > 0 && state.zonesIds.length === allIds.length
          }
          onChange={e =>
            massDeleteHandleMultipleCheckboxes(e.target.checked ? allIds : [])
          }
        />
      </div>
    ),
    width: 50,
    filterable: false,
    sortable: false,
    accessor: row => {
      const isGoodspeedZone = checkIsGoodspeedZone(row, autoSyncEnabled);

      return (
        <ConditionalWrapper
          useWrapper={isGoodspeedZone}
          renderWrapper={children => (
            <Tooltip title={t('zones.cannotDeleteGoodspeedZoneTooltip')}>
              <div>{children}</div>
            </Tooltip>
          )}
        >
          <RegularCheckbox
            customClasses={{ root: classes.checkbox }}
            disabled={isGoodspeedZone}
            checked={state.zonesIds.includes(row.id)}
            onChange={() => {
              massDeleteHandleSingleCheckbox(row.id);
            }}
          />
        </ConditionalWrapper>
      );
    },
  },
  {
    title: 'ID',
    accessor: 'id',
    name: 'id',
    filterable: false,
    sortable: false,
    width: 50,
  },
  {
    title: 'zones.name',
    name: 'name',
    accessor: 'name',
    filterable: true,
    sortable: true,
  },
  {
    title: 'zones.shortName',
    name: 'shortName',
    accessor: 'shortName',
    filterable: true,
    sortable: true,
  },
  {
    title: 'zones.category',
    name: 'category.name',
    accessor: row => row.category?.name,
    filterable: true,
    sortable: true,
  },
  {
    title: 'zones.assignedDrivers',
    name: 'drivers.name',
    accessor: row => row.drivers?.map(driver => driver?.name).join(', '),
    filterable: true,
    sortable: false,
  },
  {
    title: 'zones.codesQty',
    name: 'postCodes.code',
    accessor: row => row.postCodesLength,
    filterable: true,
    sortable: false,
  },
  {
    title: 'zones.deliveryType',
    name: 'deliveryType.value',
    accessor: row => row.deliveryType?.value,
    filterable: true,
    sortable: true,
  },
  {
    title: 'zones.hours',
    name: 'delivery-hours',
    accessor: row =>
      row.deliveryHours.map(deliveryHourConfig => {
        switch (true) {
          case deliveryHourConfig.hourFrom !== null &&
            deliveryHourConfig.hourTo !== null:
            return (
              <p>
                {new Moment(deliveryHourConfig.hourFrom).format('HH:mm')} -{' '}
                {new Moment(deliveryHourConfig.hourTo).format('HH:mm')}
              </p>
            );
          case deliveryHourConfig.hourFrom !== null:
            return (
              <p>
                {t('$*common.from')}{' '}
                {new Moment(deliveryHourConfig.hourFrom).format('HH:mm')}
              </p>
            );
          case deliveryHourConfig.hourTo !== null:
            return (
              <p>
                {t('$*common.to')}{' '}
                {new Moment(deliveryHourConfig.hourTo).format('HH:mm')}
              </p>
            );
          default:
            return '-';
        }
      }),
    filterable: false,
    sortable: false,
  },
  {
    title: 'zones.priority',
    name: 'priority',
    accessor: row => row.priority,
    filterable: true,
    sortable: true,
  },
  {
    title: 'zones.type.title',
    name: 'provider',
    accessor: row => {
      if (row.provider === 'custom') {
        return t('zones.type.custom');
      }
      return row.provider;
    },
    Filter: ({ onChange, filter }) => (
      <select
        onChange={e => onChange(e.target.value)}
        value={filter?.value || ''}
      >
        <option value="">{t('zones.type.all')}</option>
        <option value="custom">{t('zones.type.custom')}</option>
        <option value="goodspeed">{t('zones.type.goodspeed')}</option>
      </select>
    ),
    filterable: true,
    sortable: true,
  },
];

export default columnConfig;
